export const DOMAIN_URI = 'https://backend.j3techsolution.com';
export const APP_URI = 'https://aftercare.j3techsolution.com';

export const SSO_URI = 'https://sso.j3techsolution.com';
export const API_URI = `${DOMAIN_URI}/api/`;
export const APP_KEY = 'zAUygrSpzqbVADd6iSURtZtIibBcIOamoWpJT1';

export const SSO_LOGOUT = `${SSO_URI}:8443/realms/J3Tech-SSO/protocol/openid-connect/logout?client_redirect_uri=${APP_URI}/sign-in&platformId=5`;
